var map = {
	"./attunement.png": 912,
	"./dexterity.png": 501,
	"./endurance.png": 246,
	"./faith.png": 225,
	"./fp.png": 311,
	"./hp.png": 301,
	"./intelligence.png": 776,
	"./level.png": 27,
	"./luck.png": 898,
	"./slots.png": 894,
	"./stamina.png": 322,
	"./strength.png": 10,
	"./vigor.png": 956,
	"./vitality.png": 379,
	"./weight.png": 477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 630;